import { 
    // Page, 
    Text, 
    View
} from '@react-pdf/renderer';

import { styles } from '../styles/styles';

// import { useSystemUtils } from '../../../../hooks/useSystemUtils'

// package label
export function BodyMainFooterStyle1(props){

    const {
        data, 
        document,
        pageNumber,
        totalPages 
    } = props

    // const totalQty = summary?.totalQty? summary.totalQty.toFixed(2) : 0.00

    const innerStyles = {
        table: { 
            display: "table", 
            // borderStyle: "solid", 
            // borderWidth: 1, 
            // borderRightWidth: 0, 
            // borderBottomWidth: 0,
            width: '100%'
        }, 
        tableRow: { 
            margin: "auto", 
            flexDirection: "row" ,
            width: '100%'
        }, 
        tableCol: { 
            width: "50%", 
            // borderStyle: "solid", 
            // borderWidth: 1, 
            // borderLeftWidth: 0, 
            // borderTopWidth: 0 
        }, 
        tableCell: { 
            textAlign: 'left',
            padding: 3,
            ...styles.h13
        }
    };

    return (
        <View 
            style={{ 
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                borderTopColor: '#000',
                borderTopWidth: 1,
                borderTopStyle: 'solid'
            }}
        >
            <View
                style={{
                    width: '65%',
                    padding: 5
                }}
            >
                <View style={innerStyles.table}>

                    <View style={{ marginTop: 0 }}>
                        <Text style={[styles.h8]}>
                            Packed By {data?.ax_createusername}
                        </Text>
                        <Text style={[styles.h8]}>
                            {data?.ax_createdatetime}
                        </Text>
                    </View>
                </View>
            </View>
            <View
                style={{
                    width: '35%',
                    height: '100%',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderLeftWidth: 1,
                    borderLeftStyle: 'solid',
                    borderLeftColor: '#000',
                    padding: 5
                }}
            >
                <Text style={[styles.h30, styles.textBold]}>
                    {pageNumber} / {totalPages}
                </Text>
                <Text style={[styles.h10]}>
                    {data?.uom_lbl} {`(${data?.packing_type[0].toUpperCase()})`}
                </Text>
            </View>
        </View>
    )

}
